export function isiOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}

export function isAndroid(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /android/.test(navigator.userAgent.toLowerCase());
}

export function isMacOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  return /macintosh|mac os x/.test(ua) && !isiOS();
}

export function isChromeiOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /crios/i.test(navigator.userAgent.toLowerCase());
}

export function isSafariOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  return /safari/.test(ua) && !/chrome|crios|chromium|edg|opr|fxios|brave/.test(ua);
}

export function isChrome(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  return /chrome/.test(ua) && !/edg|opr|crios|brave|chromium/.test(ua);
}
